import { ENTITLEMENTS, type Entitlement } from './entitlements'
import type { Tier } from './tierForBuild'

/**
 * Which entitlements a tier grants — #477. Supersedes `grantedForBuild`.
 *
 * **`grantedForBuild(false) → []` was a pinned acceptance criterion of
 * #460, and this deliberately drops that contract.** #460's `grantedForBuild`
 * took a boolean — "is this build non-production" — and answered "all seven
 * or none". That collapsed two different questions into one: WHICH tier a
 * build is, and WHAT a tier grants. #460's own boolean made every
 * non-production build (dev AND staging alike) `true`, which is what erased
 * the only enforcement of the one-manual-account cap (`isOverFreeCap`) on
 * staging — the tenant that holds real bank data. `tierForBuild(MODE)` now
 * answers the first question, narrowing staging to `'free'`; this function
 * answers only the second, and is a pure, static table with no MODE, no
 * boolean and no build-flag awareness of its own. The reasoning for the
 * split, and why it is sanctioned rather than a regression, is recorded on
 * issue #477.
 *
 * `'premium'` still grants literally `ENTITLEMENTS` — the same value
 * `grantedForBuild(true)` produced — so every gate in the app stays
 * reachable on the builds that are meant to reach it (the vite dev server,
 * `build:dev`) and `PremiumGate.test.tsx`'s locked-branch coverage is
 * unaffected.
 *
 * `'free'` grants none, which is the safe direction: an open-by-default gate
 * gives away paid features, and `EntitlementsProvider`'s own docblock says
 * so.
 */
export function entitlementsForTier(tier: Tier): readonly Entitlement[] {
  return tier === 'premium' ? ENTITLEMENTS : []
}
